import React from 'react';
import background from '../images/bg.jpg';

const TypeWriter = () => {

  return (
    <div>
      <div className='py-4  mt-10 rounded-t-full flex flex-col shadow-2xl'>

        <h1 className='font-bold text-2xl text-main text-center '>כדורי עיצוב ארונות</h1>
        <div className="h-[1px] w-[240px] mx-auto mt-4 bg-line"></div>
      </div>
    </div>
  );
};

export default TypeWriter;
